import { placeRoutes } from "./places";
import Dashboard from "../pages/dashboard";
import { notificationRoutes } from "./notifications";
import { articleRoutes } from "./articles";
import { userRoutes } from "./users";
import { forumRoutes } from "./forum";

export const protectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  ...placeRoutes,
  ...notificationRoutes,
  ...userRoutes,
  ...forumRoutes,
  ...articleRoutes,
];
